import api from './api';

/**
 * Admin service for master admin reports
 */
const adminService = {
  /**
   * Get all users with their activity summary
   */
  getUserReports: async () => {
    const response = await api.get('/admin/reports/users');
    return response.data;
  },

  /**
   * Get overall system usage summary
   */
  getSummary: async () => {
    const response = await api.get('/admin/reports/summary');
    return response.data;
  },

  /**
   * Get recent activity across all users
   * @param {number} limit - Number of activities to fetch (default: 50)
   */
  getActivity: async (limit = 50) => {
    const response = await api.get(`/admin/reports/activity?limit=${limit}`);
    return response.data;
  }
};

export default adminService;
